export default {"src":"/_next/static/media/ra-prioritized.07081dcd.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};